import { optionalStringQueryParam, useQueryStringParam } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { ControlledTabsContainer } from "./ControlledTabsContainer";
export type UrlNavigationTabsContainerProps<TValue extends string = string> = React.PropsWithChildren<{
    defaultValue: TValue;
    urlParameterName?: string;
}>;
export function UrlNavigationTabsContainer<TValue extends string>({ defaultValue, urlParameterName, children }: UrlNavigationTabsContainerProps<TValue>) {
    const urlParameterNameParameter = optionalStringQueryParam(urlParameterName ?? "activeTab");
    const [value, setValue] = useQueryStringParam(urlParameterNameParameter);
    return (<ControlledTabsContainer value={value ?? defaultValue} onChange={setValue}>
            {children}
        </ControlledTabsContainer>);
}
export default UrlNavigationTabsContainer;
